export const constantTxt = {
  user: 'User',
  manageDelegation: 'Manage Delegation',
  delegatorUser: 'Delegator User',
  delegateeUser: 'Delegatee User',
  period: 'Period',
  delegationBy: 'Delegation By',
  addNewDelegation: 'Add New Delegation',
  deleteSelectedDelegation: 'Delete Selected Delegation',
  search: 'SEARCH',
  startDate: 'Start Date',
  endDate: 'End Date',
  listsOfDelegation: 'Lists of Delegation',
  newDelegation: 'New Delegation',
  delegationPeriodDesc: 'This delegation will be in effect during the period',
  from: 'From',
  through: 'Through',
  delegateTo: 'Delegate to',
  save: 'SAVE',
  delegationAssignedTo: 'Delegation assigned to',
  addNewRequestPnA: 'Add New Request P&A',
  viewOtherRequestPnA: 'View Other Request P&A',
  adminAssignBuyer: 'Admin Assign Buyer',
  assignBuyer: 'Assign Buyer',
  attachInfoPnA: 'Attach Information P&A',
  viewRequestPnA: 'View Request P&A',
  editRequestPnA: 'Edit Request P&A',
  partialEditRequestPnA: 'Partial Edit Request P&A',
  addNewItem: 'Add New Item',
  editItem: 'Edit Item',
  viewItem: 'View Item',
  cycleTimeReportofPnA: 'Cycle Time Report of P&A',
  location: 'Location',
  purchasingOffice: 'Purchasing Office',
  status: 'Status',
  buyer: 'Buyer',
  requestBy: 'Request By',
  companyCode: 'Company Code',
  PnaNo: 'P&A No',
  createDateFrom: 'Create Date From',
  to: 'To',
  htmlReportButton: 'HTML REPORT',
  excelReportButton: 'EXCEL REPORT',
  reportPna: 'Report P&A',
  statusChangeFrom: 'Status Change From',
  statusChangeTo: 'Status Change To',
  statusChangeDate: 'Status Change Date',
  pnaCreateDate: 'P&A Create Date',
  createdDate: 'Created Date',
  updatedBy: 'Updated By',
  noDataAvailable: 'No data available.',
  lovAll: 'ALL',
  itemDescriptionReportPnA: `Item's Description Report P&A`,
  itemDescription: 'Item Description',
  itemDetailsReportPnA: 'Item Details Report P&A',
  PnaStatus: 'P&A Status',
  manufacturers: 'Manufacturers',
  itemNo: 'Item No.',
  itemQty: 'Item Qty',
  ItemUOM: 'Item UOM',
  jDEItem: 'JDE Item#',
  qACode: 'QA Code',
  suggestedSupplier: 'Suggested Supplier',
  itemPriority: 'Item Priority',
  itemComment: 'Item Comment',
  submittedDate: 'Submitted Date',
  pnaTitle: 'P&A Title',
  requestorName: 'Requestor Name',
  itemCount: 'Item Count',
  updatedDate: 'Updated Date',
  loadingCAIsearch: 'Loading CAI search...',
  searchCAI: 'Search CAI',
  searchTerm: 'Search Term',
  searchTxt: 'Search',
  selectCAI: 'Select CAI',
  select: 'SELECT',
  loadingCAIdata: 'Loading CAI data...',
  groupName: 'group_name',
  groupMail: 'group_mail',
  noCAIData: 'No CAI entries found. Try entering a search term in the parent form and try again.',
  popupContentGoesHere: 'Popup content goes here...',
  searchGroupEmail: 'Search Group Email',
  note: 'NOTE',
  activeDirGroupName: 'If searching for an Active Directory (AD) Group, please enter the full AD group name',
  activeDirDisplayName: 'If searching for an Active Directory (AD) User, please full AD user display name. ',
  activeDirSearch: `Please search the AD User's "Display Name" in `,
  hereLinkButtonTxt: 'here',
  orADGroupNameIn: 'or AD Group "Name" in',
  searchByGroup: 'Search By Group Name',
  groupNametxt: 'Group Name',
  groupEmailtxt: 'Group Email',
  noEmailTxt: 'No email groups found. Try entering a search term in the parent form and try again.',
  noDataFound: 'No Data Found'
};
